<app-cover-design-asset
  [gallery]="gallery()"
  [theme]="theme()"
  [previewAsset]="previewAsset()"
  [noAsset]="noAsset()"
></app-cover-design-asset>
